import { render } from "./HotelPlaceOrder.vue?vue&type=template&id=edb2c2f8&scoped=true"
import script from "./HotelPlaceOrder.vue?vue&type=script&lang=js"
export * from "./HotelPlaceOrder.vue?vue&type=script&lang=js"

import "./HotelPlaceOrder.vue?vue&type=style&index=0&id=edb2c2f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb2c2f8"]])

export default __exports__